import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/Industries/Eccomerce.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/JsonLd.tsx");
